var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcStarBorder = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "nxazei1pka",
    d: "M20.167 8.47l-6.591-.568L11 1.833 8.424 7.911l-6.59.559 5.004 4.336-1.503 6.444L11 15.83l5.665 3.42-1.494-6.444 4.996-4.336zM11 14.117l-3.447 2.08.917-3.923-3.043-2.64 4.015-.348L11 5.592l1.568 3.703 4.014.348-3.043 2.64.917 3.924L11 14.117z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "the7a46deb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nxazei1pka"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#BEC4CA",
    mask: "url(#the7a46deb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H45.833V45.833H0z",
    transform: "translate(-11.917 -11.917)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcStarBorder, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-star-border.8de05040.svg";
export { ForwardRef as ReactComponent };